import { useHistory, useParams } from 'react-router-dom';

type UseDynamicUrlProps = {
    route: string;
};

type CreateDynamicUrlProps<T> = {
    route: string;
    replaceParams: {
        [property in keyof T]: string;
    };
};

export function createDynamicUrl<T>({ route, replaceParams }: CreateDynamicUrlProps<T>) {
    return Object.keys(replaceParams).reduce((accum, key) => {
        return accum.replace(`:${key}`, replaceParams[key as keyof T]);
    }, route);
}

export default function UseDynamicUrl<T>({ route }: UseDynamicUrlProps) {
    const history = useHistory();
    const params = useParams<T>();
    const path = createDynamicUrl({ route, replaceParams: params });
    return { clickHandler: () => history.push(path), path };
}
